import { Environments } from './environments.enum';
import { ErrorSeverityLevel } from './error-severity-level.enum';
import { NavigationRoutesForRouter } from './navigation-routes-for-router.enum';

export class Enums {
  static Environments = Environments;
  static ErrorSeverityLevel = ErrorSeverityLevel;
  static NavigationRoutesForRouter = NavigationRoutesForRouter;
}
